import { render, staticRenderFns } from "./absenceSummate.vue?vue&type=template&id=2720cfb5&scoped=true&"
import script from "./absenceSummate.vue?vue&type=script&lang=js&"
export * from "./absenceSummate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2720cfb5",
  null
  
)

export default component.exports